<template>
  <div>
    <b-form @submit.prevent="$emit('processLogin', { userId, userPass })">
      <b-input
        v-model="userId"
        type="email"
        id="feedback-user"
        size="lg"
        placeholder="Email"
        class="text-center mb-1"
        required
      ></b-input>

      <b-input
        v-model="userPass"
        type="password"
        id="text-password"
        size="lg"
        placeholder="Password"
        class="text-center"
        required
      ></b-input>

      <b-link
        @click="$parent.modalResetPass = true"
        class="text-right text-light my-2 d-block"
      >
        Forgot password
      </b-link>

      <b-form-text
        text-variant="light"
        class="mt-3 bg-danger px-1 rounded text-center"
      >
        <small>
          {{ errorMessage }}
        </small>
      </b-form-text>

      <b-button
        type="submit"
        variant="warning"
        class="mt-4 mx-auto w-100"
        size="lg"
      >
        Log in
      </b-button>
    </b-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      userId: "",
      userPass: ""
    };
  },
  computed: {
    ...mapGetters("user", ["errorMessage"])
  },
  methods: {
    processLogin() {
      this.$router.push("/");
    }
  }
};
</script>
